<template>
  <div class="contact fullHeight">


    <div class="container fullHeight is-fluid noMargin">
      <div class="columns fullHeight">
        <div class="column contactHalf fullHeight">
          <div id="map">
<!--            <iframe-->
<!--              width="450"-->
<!--              height="250"-->
<!--              frameborder="0" style="border:0"-->
<!--              src="https://www.google.com/maps/embed/v1/search?key=AIzaSyBpCQHW5PMFtRVxFOU3tScUSb6DIyIeif8&q=record+stores+in+Seattle" allowfullscreen>-->
<!--            </iframe>-->
          </div>
        </div>
        <div class="column contactBox">
          <h1>CONTACT</h1>
          <div class="section">
            <div class="container">
              <h3> TELEPHONE </h3>
              <p>+90 533 424 85 00 - +90 533 425 85 00</p>
              <br>
              <h3> FAX </h3>
              <p>+90 212 385 00 05</p>
              <br>
              <h3> E-MAIL </h3>
              <p>info@sarikayasahin.com</p>
              <br>
              <h3> ADDRESS </h3>
              <p>Balmumcu Mah. Zincirlikuyu Yolu Sok. No: 5/1, Besiktas, Istanbul</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <span class="contactOverlay"></span> -->
  </div>
</template>

<script>

  export default {
    name: 'contact',
    data() {
      return {}
    },
    mounted: function () {
    //   let locate = null;
    //   window.innerWidth > 500 ? locate = {lat: 41.0620881, lng: 29.0098528} : locate =  {lat: 41.0805581, lng: 29.0217118};
    //   let map = new google.maps.Map(document.getElementById('map'), {
    //     center: locate,
    //     zoom: 15,
    //     styles: [
    //       {
    //         "featureType": "administrative",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#444444"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "color": "#f2f2f2"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.man_made",
    //         "elementType": "geometry.stroke",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           },
    //           {
    //             "color": "#f70000"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.landcover",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "labels.text",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "landscape.natural.terrain",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.attraction",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "geometry.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#a9f07e"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "poi.park",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "hue": "#2dff00"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "saturation": -100
    //           },
    //           {
    //             "lightness": "48"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           },
    //           {
    //             "color": "#ffffff"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels",
    //         "stylers": [
    //           {
    //             "visibility": "simplified"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#666464"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.highway",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.arterial",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "color": "#4d4d4d"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.arterial",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#acacac"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "lightness": "69"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.text.fill",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           },
    //           {
    //             "color": "#393939"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.text.stroke",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "road.local",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "geometry",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "labels.text",
    //         "stylers": [
    //           {
    //             "visibility": "off"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "transit.line",
    //         "elementType": "labels.icon",
    //         "stylers": [
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       },
    //       {
    //         "featureType": "water",
    //         "elementType": "all",
    //         "stylers": [
    //           {
    //             "color": "#aad2e3"
    //           },
    //           {
    //             "visibility": "on"
    //           }
    //         ]
    //       }
    //     ]
    //   });
    //   let icon = "/static/favicon.png"
    //   let marker = new google.maps.Marker({
    //     position: {lat: 41.080675, lng: 29.022300},
    //     map: map,
    //     title: 'Sarıkaya Şahin Hukuk',
    //     image: icon
    //   });
    // }
  }}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .contact p {
    font-size: 1.5rem;
    color: #bbbbbb;
  }

  .contactOverlay {
    background: rgba(0, 0, 0, 0.58);
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
    width: 50%;
  }

  .contactBox {
    background: rgba(0, 0, 0, 0.78);
    z-index: 3;
    margin: auto;
    padding: 0px 55px;
    box-shadow: -5px 1px 20px 0px rgb(0, 0, 0);
  }

  #app {
    background: #606c96;
  }

  .fullHeight {
    height: 86.5vh;
  }

  .noMargin {
    margin: 0;
  }

  .contact h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .contact h1 {
    position: relative;
    color: #fff;
    font-family: 'SEC', sans-serif;
  }

  .contact h3 {
    position: relative;
    color: #c3c3c3;
    font-size: 23px;
  }

  #map {
    position: absolute !important;
    /* z-index: -2; */
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: url("../../../static/map.png");
    background-position: center;
    background-size: cover;
  }

  .contactHalf {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 61%;

  }

  .section {
    padding: 1rem 1.5rem 1rem 1.5rem !important;
  }

  @media only screen and (max-width: 768px) {
    .fullHeight {
      height: 42vmax;
    }

    .contact h1 {
      font-size: 1.9rem;
    }

    .contact h3 {
      font-size: 18px;
    }

    .contact p {
      font-size: 1.1rem;
    }

    .contactBox {
      max-height: 56vmax;
      margin-bottom: 50px;
    }
  }


</style>



// WEBPACK FOOTER //
// contact.vue?5f330f85